import React, { useContext, useState, useEffect } from "react";
import { SignupContext } from "../../../../context/SignupContext";
import * as Yup from "yup";
import Button from "../../../../components/Button";
import { Link, useNavigate } from "react-router-dom";
import { updatePassword } from "firebase/auth";
import { auth } from "../../../../firebase/firebase";
import { Timestamp, setDoc } from "firebase/firestore";
import { updateUser } from "../../../../api/accounts/userServices";

const Step4 = () => {
  const { formData, updateFormData } = useContext(SignupContext);
  const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({});
  const [isFormValid, setIsFormValid] = useState(false);
  const navigate = useNavigate();
  const schema = Yup.object({
    password: Yup.string().required("Password is required").min(8, "Password must be at least 8 characters long"),
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password")], "Passwords must match"),
  });

  const setNewPassword = async (e: React.FormEvent) => {
    e.preventDefault();

    if (auth.currentUser) {
      try {
        await updatePassword(auth.currentUser, formData.password);
        await updateUser(auth.currentUser.uid, {
          lastPasswordChange: Timestamp.now(),
        });

        navigate("../twofactor");
      } catch (err) {
        console.log(err);
      }
    }
  };

  // useEffect(() => {
  //   setErrors({ password: "", confirmPassword: "" });
  //   if (auth.currentUser && auth.currentUser.email) {
  //     const credential = EmailAuthProvider.credential(auth.currentUser.email, auth.currentUser.email);
  //     reauthenticateWithCredential(auth.currentUser, credential);
  //   }
  //   return () => {};
  // }, []);

  const updateValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const newValue = { ...formData, [name]: value };
    updateFormData(newValue);
  };

  const onInputEvent = async (event: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (event.type === "focus") {
      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return;
    }
    if (isFormValid) return;
    try {
      await schema.validateAt(name, { [name]: value });
      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return true;
    } catch (err) {
      let error = err as Yup.ValidationError;
      setErrors(prev => ({ ...prev, [name]: error.message }));
    }
  };

  useEffect(() => {
    const validate = async (data: { [key: string]: string | undefined }) => {
      try {
        await schema.validate(data, { abortEarly: true });
        setIsFormValid(true);
        setErrors({});
      } catch (err) {
        setIsFormValid(false);
      }
    };
    const { password, confirmPassword } = formData;
    validate({ password, confirmPassword });
  }, [formData]);

  return (
    <section>
      <div className="container">
        <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
          {/* Left Container */}
          <div className="flex flex-col items-start justify-start">
            <h1 className="herotitle">Skarvo</h1>
            <p className="text-xl font-normal">Choose a strong password.</p>
          </div>

          {/* Right Container */}
          <div className="flex flex-col gap-10">
            <div className="flex flex-col items-start formcard">
              <div className="flex flex-row items-start formheader">
                <div className="text-xl font-bold text-center mt-[15px] mb-[30px]">Sign Up</div>
              </div>
              <div className="flex justify-center w-full px-[30px] mb-[30px]">
                <div className="bg-gray-200 w-full rounded-full h-[5px]">
                  <div className="bg-green-600 h-[5px] rounded-full" style={{ width: "50%" }}></div>
                </div>
              </div>

              <div className="mb-5 px-[30px] flex flex-col space-y-[10px] w-full">
                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Add password
                </label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Password"
                  required
                  onChange={updateValue}
                  onBlur={onInputEvent}
                  onFocus={onInputEvent}
                />
                {errors.password && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{errors.password}</span>}

                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Confirm password
                </label>
                <input
                  type="password"
                  name="confirmPassword"
                  id="confirmPassword"
                  className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Confirm password"
                  required
                  onBlur={onInputEvent}
                  onFocus={onInputEvent}
                  onChange={updateValue}
                />
                {errors.confirmPassword && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{errors.confirmPassword}</span>}
              </div>

              <div className="thickseparator"></div>
              <div className="flex flex-col items-center justify-between w-full px-[30px] py-[20px] md:flex-row-reverse  gap-y-[30px]">
                <Button to="#" onClick={setNewPassword} className="w-full md:w-auto md:min-w-[120px] formprimarybutton" isDisabled={!isFormValid}>
                  Continue
                </Button>
                <Link to="/login" className="w-full md:w-auto md:min-w-[120px] formsecondarybutton">
                  Cancel
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Step4;
